require.register("user/controllers/editCtrl", function(exports, require, module){
  $0
  
});

